// main.ts
import xml from "csi/xml";
import { Action } from "csi/def/Action";
import { Context } from "csi/def/Context";

/**
 * On creating Product on ProductHierarchyDetails, set the newly created Product's ProductHierarchyDetails ref to the curent node
 */
export function onActionProductHierarchyDetailsNewProduct(ac): void {
	ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("ProductHierarchyDetails", xml.ATTR_REF, ac.m_urlParent);
}

/**
 * Determines if user has write access to the Product's ProductHierarchyDetails ref.
 */
export function onAccessActionResetHierarchy(ctx: Context, action: Action): boolean {
	return xml.nodeHasAccess(ctx.getNode(), xml.RIGHT_WRITE, "ProductHierarchyDetails");
}
